import { useContext, useEffect } from "react";
import { UserContext } from "../contexts/UserContext/UserContextProvider";
import { authContext } from "../contexts/AuthContext/AuthContextProvider";
import styles from "./layoutStyles.module.scss";
import OTPForm from "../components/Signup/partials/OTPForm/OTPForm";
import { Loader } from "../components/RestrictedMessage/RestrictedMessage";
const AuthLayout = ({ children }) => {
  const { anonymousUser, loading } = useContext(UserContext);
  const { state, toggleSignInbtn } = useContext(authContext);
  const { showOTPModal } = state;

  useEffect(() => {
    if (loading) {
      return;
    }
    if (anonymousUser) {
      if (!showOTPModal) {
        toggleSignInbtn("showOTPModal", true);
      }
    }
  }, [anonymousUser, loading, toggleSignInbtn]);
  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      {showOTPModal ? (
        <div className={`modalOverlayWithBlur ${styles["OTPContainer"]}`}>
          <div className={styles.box}>
            <OTPForm />
          </div>
        </div>
      ) :
        <div>{children}</div>
      }
    </div>
  );
};

export default AuthLayout;
